import { logEvent } from "@/analytics/analytics"
import { H1, H2 } from "@/components/ui/headings"
import { MainLayout } from "@/org-admins/layouts/MainLayout"
import { useMutation } from "@apollo/client"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import SignInForm from "../components/SignInForm"
import { confirmOrgAdminEmailMutation } from "./api"

export const ConfirmEmailScreen = () => {
  const { confirmationToken } = useParams<{ confirmationToken: string }>()
  const [execConfirmEmail] = useMutation(confirmOrgAdminEmailMutation)

  const [error, setError] = useState<string | null>(null)
  const [verificationSuccess, setVerificationSuccess] = useState(false)

  const onConfirm = async () => {
    logEvent("Confirmed org admin user email")

    const { data } = await execConfirmEmail({
      variables: { input: { confirmationToken: confirmationToken ?? "" } },
    })

    if (
      data?.confirmEmailAddress.errors &&
      data?.confirmEmailAddress.errors.length > 0
    ) {
      setError(data.confirmEmailAddress.errors[0].fullMessages[0])
    } else {
      setVerificationSuccess(true)
    }
  }

  useEffect(() => {
    onConfirm()
  }, [confirmationToken])

  return (
    <MainLayout showLogo={true}>
      {error ? (
        <>
          <div className="mb-12">
            <H2>{error}</H2>
          </div>
          <SignInForm />
        </>
      ) : verificationSuccess ? (
        <>
          <div className="mb-12">
            <H1>Verification Success!</H1>
            <H2>
              We have found your email and linked it to the organization. Please
              sign in to manage the details of your organization.
            </H2>
          </div>
          <SignInForm />
        </>
      ) : (
        <div className="mb-12">
          <H2>Verifying...</H2>
        </div>
      )}
    </MainLayout>
  )
}
